import React, { useEffect, useState } from 'react'
import PayPalPayment from './PaypalPayment';
import { useParams, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';

const PaypalButton = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [isValidToken, setIsValidToken] = useState(false);
  const [details, setDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setError('No token provided');
        setIsLoading(false);
        return;
      }

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_MOBILE_BASEURL}/api/billing/paymenttokenvefiy`,
          {
            token: token
          }
        );

        if (response.data.data) {
          setDetails(response.data.data.paypal);
          setIsValidToken(true);
          // console.log('Payment details:', response.data.data.paypal);
        } else {
          setError('Invalid response from server');
        }
      } catch (error) {
        setError(error.message || 'Failed to verify token');
        // navigate('/error');
      } finally {
        setIsLoading(false);
      }
    };

    verifyToken();
  }, [token, navigate]);

  if (isLoading) {
    return <div>Verifying payment details...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!isValidToken || !details) {
    return <div>Invalid payment token</div>;
  }

  return (
    <div>
      <h1>PayPal Payment Integration</h1>
      <PayPalPayment token={token} amount={details.amount_paid}  course_id={details?.course_id} membership_id={details?.membership_id} />
      <a href='e2t://com.educate2trade.e2t/open?value=success'>link to app</a> <br />
      <a id="launchApp" href="e2t://com.educate2trade.e2t.ios/open?value=success">IOS redirection</a>
    </div>
  );
};

export default PaypalButton;